
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import { getter } from '../../../../utility/fp';

export const distributionSupplierGetters = {
  distributionSupplierData: (state) => state.distributionSupplierData,
  supplierList: (state) => state.supplierList,
  supplierDetails: (state) => state.supplierDetails,

}